import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { Box, Card, CardContent, Typography } from "@mui/material";
import contactRosterGraphic from "../../assets/images/ContactRoster1.svg";
import AsttHeader from "components/Common/Header/Header";
import AsttDrawer from "components/Common/SideBar/AsttDrawer";
import TabbedPanel from "components/SearchClassRoster/TabbedPanel";
import RosterConfigInputs from "components/RosterConfig/RosterConfigInputs";
import GenerateIdmTicket from "components/GenerateIdmTicket/GenerateIdmTicket";
import AssignTrainees from "components/AssignTrainees/AssignTrainees";
import CreateUpdateClassRequest from "components/ClassRequest/CreateUpdateClassRequest";
import AsttHomeRosterTable from "components/Common/AsttHomeRosterTable/AsttHomeRosterTable";
import { getTimeBasedGreetingKey, greetingThemeMap } from "utils/greetingTheme";

export default function AsttHome() {
  const { t } = useTranslation(["AsttHome"], { useSuspense: false });
  const location = useLocation();
  const [index, setIndex] = useState(0);
  const greetingKey = getTimeBasedGreetingKey();
  const greetingVisual = greetingThemeMap[greetingKey];
  const GreetingIcon = greetingVisual.Icon;

  useEffect(() => {
    const path = location.pathname.toLowerCase();
    if (path === "/home") setIndex(0);
    if (path === "/home/searchrequests") setIndex(1);
    if (path === "/home/searchtrainees") setIndex(2);
    if (path === "/home/searchrequisitions") setIndex(3);
    if (path === "/home/searchrosters") setIndex(4);
    if (path === "/home/rosterconfig") setIndex(5);
    if (path === "/home/component02") setIndex(6);
    if (path === "/home/generateidmticket") setIndex(7);
    if (path === "/home/createclassrequest") setIndex(8);
    if (path === "/home/assigntrainees") setIndex(9);
  }, [location.pathname]);

  // Must match the width of AsttDrawer
  const drawerWidth = 80; // Adjust according to AsttDrawer's minWidth + paddingX

  return (
    <Box sx={{ display: "flex", minHeight: "100vh" }}>
      {/* Sidebar */}
      <AsttDrawer index={index} />

      {/* Main content area */}
      <Box
        sx={{
          flexGrow: 1,
          marginLeft: `${drawerWidth}px`,
          width: `calc(100% - ${drawerWidth}px)`,
        }}
      >
        <AsttHeader title={t("astt")} logoURL="/home" version="new" />

        <Box sx={{ padding: 2 }}>
          {index === 0 && (
            <Card
              sx={{
                mb: 2,
                borderRadius: "12px",
                boxShadow: "0 6px 20px rgba(15, 23, 42, 0.08)",
              }}
            >
              <CardContent>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Box
                    component="img"
                    src={contactRosterGraphic}
                    alt="TTEC"
                    sx={{ height: 60, width: 60 }}
                  />
                  <Typography
                    sx={{
                      fontWeight: "normal",
                      marginLeft: 1,
                      fontFamily: "Urbanist, sans-serif",
                      fontSize: "28px",
                      color: "#CECECD",
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                    }}
                  >
                    <GreetingIcon
                      sx={{
                        fontSize: 24,
                        color: "#CECECD",
                        transform: `rotate(${greetingVisual.rotate}deg)`,
                      }}
                    />
                    {t(greetingKey)}{" "}
                    <Typography
                      component="span"
                      sx={{
                        fontFamily: "Urbanist, sans-serif",
                        fontSize: "28px",
                        fontWeight: "bold",
                        color: "#3F5765",
                      }}
                    >
                      {localStorage.getItem("User")}
                    </Typography>
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          )}

          {index === 0 && <AsttHomeRosterTable />}

          {index === 1 && <TabbedPanel currentIndex={0} />}
          {index === 2 && <TabbedPanel currentIndex={1} />}
          {index === 3 && <TabbedPanel currentIndex={2} />}
          {index === 4 && <TabbedPanel currentIndex={3} />}
          {index === 5 && <RosterConfigInputs />}
          {index === 7 && <GenerateIdmTicket />}
          {index === 8 && <CreateUpdateClassRequest />}
          {index === 9 && <AssignTrainees />}
        </Box>
      </Box>
    </Box>
  );
}
